import { connect } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import { Map as ImmutableMap } from 'immutable';

import { getEditHistoryEnabled } from 'selectors/session';

import Section from 'features/timesheets/TimesheetsPage/TimecardModal/Section';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';
import { EVENT_ACTIONS } from 'util/tracking_constants';

import EditHistoryEvent from './EditHistoryEvent';
import Paywall from './Paywall';

const { cx } = cxHelpers('EditHistory');

interface EditHistoryProps {
  events: any;
  featureAvailable: boolean;
  showBottomBorder: boolean;
}

const EditHistory = ({
  events,
  featureAvailable,
  showBottomBorder = true,
}: EditHistoryProps) => {
  function renderEvents() {
    if (!featureAvailable) {
      return <Paywall />;
    }

    return events.map(
      (activitiesGroup: ImmutableMap<string, any>, i: number) => (
        <EditHistoryEvent activitiesGroup={activitiesGroup} key={i} />
      )
    );
  }

  return (
    <Box className={cx()}>
      <Section
        bottomBorder={showBottomBorder}
        bottomPadding
        iconName="Overtime"
        expandedContent={renderEvents()}
        trackingAction={EVENT_ACTIONS.EDIT_HISTORY_CLICKED_V3}
        title={toI18n('timecard_modal_v3.edit_history_section.title', {
          props: { count: events.size },
        })}
      />
    </Box>
  );
};

export default connect(state => ({
  featureAvailable: getEditHistoryEnabled(state),
}))(EditHistory);
